import { merge } from 'lodash';
import type { UserPrefs } from '../../../generated';
import { ReactiveMap } from '../../../utils/ReactiveMap';

export const defaultUserPrefs: Omit<UserPrefs, 'id'> = {
  privateCommentsEnabled: false,
  timeDisplayFormat: 'TIMECODE',
  downloadSettings: {
    locations: [],
    shouldImport: false,
    __typename: 'UserPrefsDownloadSettings',
  },
  exploreTemplatesBannerSettings: {
    shouldShowExploreTemplatesBanner: true,
    __typename: 'UserPrefsExploreTemplatesBannerSettings',
  },
  previewEnvironmentBanner: true,
  transcriptionsLanguage: 'en-US',
  hasTranscriptionConsent: true,
  __typename: 'UserPrefs',
};

export const userPrefsMap = new ReactiveMap<string, UserPrefs, 'userPrefsMap'>(
  'userPrefsMap'
);

const userPrefs = userPrefsMap.get('default-user');

// default-share-user can be used in the future to set
// additional user prefs specific to shares
const shareUserPrefs = userPrefsMap.get('default-share-user');
const mergedDefaultAndUserPrefs = merge(
  { id: 'default-user' },
  defaultUserPrefs,
  userPrefs
);

const mergedShareDefaultAndUserPrefs = merge(
  { id: 'default-share-user' },
  defaultUserPrefs,
  shareUserPrefs
);

userPrefsMap.set('default-user', mergedDefaultAndUserPrefs);
userPrefsMap.set('default-share-user', mergedShareDefaultAndUserPrefs);
